module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/core/page-not-found/page-not-found.component.css
// module id = ./src/app/core/page-not-found/page-not-found.component.css
// module chunks = main